module.exports = __webpack_public_path__ + "media/hecai.95a26b4d.mp3";